module.exports = __webpack_public_path__ + "img/mail-icon-white.38af6ac3.svg";